<div class="d-flex position-relative">
  <a class="btn d-flex align-items-center ml-2" 
    [ngClass]="{
      'icons-fill-color': 
        environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
        !environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND,
      'header-icons-text-color header-icons-border-color':
        environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
        environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND,
      'text-brand border-brand': !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR
    }"
    role="button" 
    (click)="showLangDropdown = !showLangDropdown">
    <mat-icon class="material-icons mr-1" aria-hidden="false">
      language
    </mat-icon>
    <span class="d-sm-block d-none mx-1" [ngClass]="{'mb-1': lang === 'ar'}">
      {{ lang == 'en' ? 'English' : 'عربي'}}
    </span>
    <mat-icon class="material-icons" aria-hidden="false">
      expand_more
    </mat-icon>
  </a>

  <div class="dropdown-container bg-white py-2" *ngIf="showLangDropdown">
    <div class="dropdown-item font-family-en px-sm-4" [ngClass]="{'disabled': lang === 'en'}"
      (click)="changeDirection('en'); showLangDropdown = !showLangDropdown">
      English
    </div>
    <div class="dropdown-item font-family-ar px-sm-4" [ngClass]="{'disabled': lang === 'ar'}"
      (click)="changeDirection('ar'); showLangDropdown = !showLangDropdown">
      عربي
    </div>
  </div>
</div>